module.exports = __webpack_public_path__ + "img/exam-complete.56621961.png";